import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes } from 'react-router';
import { Container } from 'reactstrap';
import { toast, ToastContainer, Slide } from 'react-toastify';

import NavigationBar from '../containers/NavigationBar';
import ResponsesPage from '../containers/ResponsesPage';
import ProfilePage from '../containers/ProfilePage';
import Footer from '../components/Footer';
import LicenseAgreement from '../components/LicenseAgreement';
import NotFoundPage from '../components/NotFoundPage';
import preloader from '../assets/img/preloader.gif';
import WebSocketInstance, { WSCommands } from '../utils/websocket';
import AllVacanciesPage from '../containers/AllVacanciesPage';
import VacancyPage from '../containers/VacancyPage';
import ResponseReview from '../containers/ResponseReview';
import ResumePage from '../containers/ResumePage';
import EditResume from '../containers/EditResume';


const onNewMessage = (data) => {
  const { message, status } = data;
  toast[status](message);
};

const PrivateRoutes = ({ dataLoaded }) => {
  useEffect(() => {
    if (!import.meta.env.PROD) {
      return undefined;
    }
    if (localStorage.getItem('token')) {
      WebSocketInstance.connect();
      WebSocketInstance.addCallbacks({ [WSCommands.SHOW_MESSAGE]: onNewMessage });
    }
    return () => {
      WebSocketInstance.removeCallbacks([WSCommands.SHOW_MESSAGE]);
    };
  }, []);

  return (
    <>
      <ToastContainer
        transition={Slide}
        autoClose={15000}
        newestOnTop
        pauseOnFocusLoss
        hideProgressBar
      />
      <NavigationBar />
      <Container className="private-page-container">
        {dataLoaded
          ? (
            <Routes>
              <Route path="/" element={<Navigate to="/all-vacancies" replace />} />
              <Route path="/all-vacancies" element={<AllVacanciesPage />} />
              <Route path="/all-vacancies/:id" element={<VacancyPage />} />
              <Route path="/responses" element={<ResponsesPage />} />
              <Route path="/responses/:responseId" element={<ResponseReview />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/license-agreement" element={<LicenseAgreement />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/signup" element={<Navigate to="/" replace />} />
              <Route path="/resume" element={<ResumePage />} />
              <Route path="/resume/edit-resume/" element={<EditResume />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          )
          : (
            <div className="loader">
              <img className="loader__gif" src={preloader} alt="Загрузка..." />
            </div>
          )}
      </Container>
      <Footer />
    </>
  );
};

PrivateRoutes.propTypes = {
  dataLoaded: PropTypes.bool.isRequired,
};

export default PrivateRoutes;
